import { getView, requireAuth } from '@/lib/utils';
import {
  AssetChemicalsPage,
  AssetChemicalPage,
  AssetChemicalFilesPage,
} from '@/data/appInformationItems';
import { Left } from 'Models/Menu/menus';

export default {
  path: '/asset/:keyParent/chemical-assign/:_key',
  name: 'assetChemical',
  component: getView('pages/PageAssetChemical'),
  redirect: { name: 'assetChemical-details' },
  beforeEnter: requireAuth,
  meta: {
    roles: ['operator'],
  },
  children: [
    {
      path: 'details',
      name: 'assetChemical-details',
      component: getView('assetChemicals/TabDetails'),
      beforeEnter: requireAuth,
      meta: {
        crumbs: 'Assets > Chemical > Details',
        leftMenu: Left.AssetChemical,
        information: AssetChemicalPage,
        showBottomMenu: true,
      },
    },
    {
      path: 'files',
      name: 'assetChemical-files',
      component: getView('assetChemicals/TabFiles'),
      beforeEnter: requireAuth,
      meta: {
        crumbs: 'Assets > Chemical > Files',
        leftMenu: Left.AssetChemicalFiles,
        information: AssetChemicalFilesPage,
        showBottomMenu: true,
      },
    },
    {
      path: 'edit',
      name: 'assetChemicalEdit',
      component: getView('pages/PageAssetChemicalEdit'),
      beforeEnter: requireAuth,
      meta: {
        crumbs: 'Assets > Chemical > Edit',
        leftMenu: Left.AssetsList,
        information: AssetChemicalsPage,
        showBottomMenu: true,
      },
    },
  ],
};
